import React from "react";
import { SalidasProvider } from "../Context/SalidasContext";
import SalidasContent from "./Salidas/SalidasContent";

const Salidas = () => {
  return (
    <SalidasProvider>
      <SalidasContent />
    </SalidasProvider>
  );
};

export default Salidas;